export default [{
	alt: 'Extra Ball',
	src: './products-images-wines/extra-ball.png',
	uid: 'extra-ball'
},
{
	alt: 'Morgon',
	src: './products-images-wines/morgon.png',
	uid: 'morgon'
},
{
	alt: 'La Quille',
	src: './products-images-wines/la-quille.jpg',
	uid: 'la-quille'
},
{
	alt: 'Pinot Noir',
	src: './products-images-wines/pinot-noir-bourgogne.png',
	uid: 'pinot-noir-bourgogne'
},
{
	alt: 'Le temps des Gitans Syrah',
	src: './products-images-wines/le-temps-des-gitans-syrah.jpg',
	uid: 'le-temps-des-gitans-syrah'
},
{
	alt: 'Roc & Lune',
	src: './products-images-wines/roc-et-lune.jpg',
	uid: 'roc-et-lune'
},
{
	alt: 'Côtes du Rhône',
	src: './products-images-wines/estezargues.jpg',
	uid: 'cote-du-rhone'
},
{
	alt: 'Soleil de Nuit',
	src: './products-images-wines/soleil-de-nuit.png',
	uid: 'soleil-de-nuit'
},
{
	alt: 'Sauvignon Blanc',
	src: './products-images-wines/sauvignon-blanc.jpg',
	uid: 'sauvignon-blanc'
},
{
	alt: 'Le Pigeonnier',
	src: './products-images-wines/le-pigeonnier.jpg',
	uid: 'le-pigeonnier'
},
{
	alt: 'Le Romarin',
	src: './products-images-wines/le-romarin.jpg',
	uid: 'le-romarin'
},
{
	alt: 'Le Sec',
	src: './products-images-wines/le-sec.jpg',
	uid: 'le-sec'
},
{
	alt: 'Coteaux Varois en Provence',
	src: './products-images-wines/coteaux-varois-en-provence.jpg',
	uid: 'coteaux-varois-en-provence'
},
{
	alt: 'U San Muletto',
	src: './products-images-wines/u-san-muletto.jpg',
	uid: 'u-san-muletto'
},
{
	alt: 'La vie en Orange',
	src: './products-images-wines/la-vie-en-orange.png',
	uid: 'la-vie-en-orange'
},
{
	alt: 'Pet Nat',
	src: './products-images-wines/pet-nat.jpg',
	uid: 'pet-nat'
},
{
	alt: 'Pouilly-Fuissé',
	src: './products-images-wines/pouilly-fuisse.jpg',
	uid: 'pouilly-fuisse'
},
{
	alt: 'Chant des Loups',
	src: './products-images-wines/chant-des-loups.jpg',
	uid: 'chant-des-loups'
},
{
	alt: 'Chablis',
	src: './products-images-wines/chablis.jpg',
	uid: 'chablis'
},
{
	alt: 'Champagne Cuvée Gourmandise',
	src: './products-images-wines/gourmandise.jpg',
	uid: 'gourmandise'
}
]